(() => {
  const formatMoneySafe = (cents) => {
    if (typeof cents !== 'number') return '';
    if (typeof window.formatMoney === 'function') {
      const format = window.theme?.settings?.money_with_currency_format;
      return window.formatMoney(cents, format || undefined);
    }
    const currency = window.Shopify?.currency?.active || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const getBirthstoneDrawer = () => {
    return document.querySelector('[data-side-panel-label="Pierre de Naissance"]');
  };

  const openBirthstonePanel = () => {
    const drawer = getBirthstoneDrawer();
    if (!drawer) return;
    document.body.classList.remove('open-cc--product');
    document.body.classList.add('open-cc');
    drawer.classList.add('active');
    drawer.removeAttribute('inert');
  };

  const openInfoPanel = (handle) => {
    if (!handle) return;
    let panel = document.querySelector(`.side-panel[data-side-panel-page="${handle}"]`);
    if (!panel) {
      panel = document.querySelector('.side-panel[data-side-panel-label="Nos pierres de naissance"]');
    }
    if (!panel) return;
    document.body.classList.remove('open-cc--product');
    document.body.classList.add('open-cc');
    panel.classList.add('active');
    panel.removeAttribute('inert');
  };

  const closeBirthstonePanel = () => {
    const drawer = getBirthstoneDrawer();
    if (!drawer) return;
    drawer.classList.remove('active');
    drawer.setAttribute('inert', '');
    document.body.classList.remove('open-cc');
  };

  const fetchVariantInfo = async (variantId) => {
    const response = await fetch(`/variants/${variantId}.js`, { credentials: 'same-origin' });
    if (!response.ok) return null;
    return response.json();
  };

  const loadBirthstoneData = async (birthstonePanel) => {
    if (!birthstonePanel) return;
    const items = Array.from(birthstonePanel.querySelectorAll('.birthstone-panel__item'));
    if (!items.length) return;

    await Promise.all(items.map(async (item) => {
      const input = item.querySelector('[data-birthstone-variant-id]');
      const variantId = input?.dataset.birthstoneVariantId;
      if (!variantId) return;
      const variant = await fetchVariantInfo(variantId);
      if (!variant) return;
      const titleEl = item.querySelector('.birthstone-panel__title');
      if (titleEl && (!titleEl.textContent || titleEl.textContent.trim() === '—')) {
        titleEl.textContent = variant.title || titleEl.textContent;
      }
      const priceEl = item.querySelector('[data-birthstone-price]');
      if (priceEl && typeof variant.price === 'number') {
        priceEl.textContent = formatMoneySafe(variant.price);
        item.dataset.birthstonePriceCents = String(variant.price);
      }
      const thumbEl = item.querySelector('[data-birthstone-thumb]');
      const imageUrl = variant?.featured_image?.src || variant?.image || '';
      if (thumbEl && imageUrl) {
        thumbEl.style.backgroundImage = `url(${imageUrl})`;
        thumbEl.style.backgroundSize = 'cover';
        thumbEl.style.backgroundPosition = 'center';
      }
    }));
  };

  const addAddon = async (variantId, quantityValue) => {
    if (!variantId) return false;
    const cartAddUrl = window.theme?.routes?.cart_add_url || '/cart/add.js';
    const addOnData = new FormData();
    addOnData.append('id', variantId);
    addOnData.append('quantity', quantityValue);
    const addOnResponse = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: addOnData
    });
    const addOnResult = await addOnResponse.json();
    if (addOnResult.status) {
      return false;
    }
    return true;
  };

  const removeBirthstoneFromCart = async (variantId) => {
    if (!variantId) return false;
    const cartUrl = window.theme?.routes?.cart_url ? `${window.theme.routes.cart_url}.js` : '/cart.js';
    const cartChangeUrl = window.theme?.routes?.cart_change_url || '/cart/change.js';
    try {
      const response = await fetch(cartUrl, { credentials: 'same-origin' });
      if (!response.ok) return false;
      const cart = await response.json();
      const item = cart.items?.find((entry) => String(entry.id) === String(variantId));
      if (!item) return true;
      const changeBody = JSON.stringify({
        id: item.key,
        quantity: 0,
        sections: [],
        sections_url: window.location.pathname
      });
      const changeResponse = await fetch(cartChangeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: changeBody
      });
      return changeResponse.ok;
    } catch (error) {
      return false;
    }
  };

  const setBirthstoneSelected = (birthstoneOption, birthstoneTrigger, birthstonePreview, selected, priceText, priceCents, thumbStyle) => {
    if (birthstoneTrigger) {
      birthstoneTrigger.textContent = 'Pierre déjà ajoutée';
      birthstoneTrigger.setAttribute('disabled', 'disabled');
    }
    if (birthstonePreview) {
      const previewTitle = birthstonePreview.querySelector('[data-birthstone-preview-title]');
      const previewPrice = birthstonePreview.querySelector('[data-birthstone-preview-price]');
      const previewThumb = birthstonePreview.querySelector('[data-birthstone-preview-thumb]');
      if (previewTitle) {
        previewTitle.textContent =
          selected?.closest('.birthstone-panel__item')?.querySelector('.birthstone-panel__title')?.textContent?.trim() || '';
      }
      if (previewPrice) previewPrice.textContent = priceText || '';
      if (previewThumb && thumbStyle) previewThumb.style.backgroundImage = thumbStyle;
      birthstonePreview.hidden = false;
    }
    if (birthstoneOption) {
      birthstoneOption.dataset.birthstoneSelectedId = selected?.dataset.birthstoneVariantId || '';
      birthstoneOption.dataset.birthstoneSelectedPriceCents = String(priceCents || 0);
    }
    document.documentElement.dataset.birthstonePriceCents = String(priceCents || 0);
    if (typeof window.updateAddToCartPrice === 'function') {
      window.updateAddToCartPrice(birthstoneOption?.dataset?.sectionId || '', window.theme?.currentVariantBySection?.[birthstoneOption?.dataset?.sectionId]);
    }
  };

  const clearBirthstoneSelected = (birthstoneOption, birthstoneTrigger, birthstonePreview) => {
    if (birthstoneTrigger) {
      birthstoneTrigger.textContent = 'Cliquez ici pour choisir';
      birthstoneTrigger.removeAttribute('disabled');
    }
    if (birthstonePreview) {
      const previewTitle = birthstonePreview.querySelector('[data-birthstone-preview-title]');
      const previewPrice = birthstonePreview.querySelector('[data-birthstone-preview-price]');
      const previewThumb = birthstonePreview.querySelector('[data-birthstone-preview-thumb]');
      if (previewTitle) previewTitle.textContent = '';
      if (previewPrice) previewPrice.textContent = '';
      if (previewThumb) previewThumb.style.backgroundImage = '';
      birthstonePreview.hidden = true;
    }
    if (birthstoneOption) {
      delete birthstoneOption.dataset.birthstoneSelectedId;
      delete birthstoneOption.dataset.birthstoneSelectedPriceCents;
    }
    document.documentElement.dataset.birthstonePriceCents = '0';
    if (typeof window.updateAddToCartPrice === 'function') {
      window.updateAddToCartPrice(birthstoneOption?.dataset?.sectionId || '', window.theme?.currentVariantBySection?.[birthstoneOption?.dataset?.sectionId]);
    }
  };

  const init = () => {
    const birthstoneOption = document.querySelector('[data-birthstone-option][data-section-id]');
    if (!birthstoneOption) return;
    const sectionId = birthstoneOption.dataset.sectionId || '';
    const birthstoneTrigger = birthstoneOption.querySelector('[data-birthstone-open]');
    const infoButtons = Array.from(document.querySelectorAll('[data-birthstone-info-tooltip]'));
    const giftNoteInfoButtons = Array.from(document.querySelectorAll('[data-gift-note-tooltip-open]'));
    const birthstonePreview = birthstoneOption.querySelector('[data-birthstone-preview]');
    const birthstoneRemoveButton = birthstoneOption.querySelector('[data-birthstone-remove]');
    const birthstonePanel = document.querySelector(`[data-birthstone-panel][data-section-id="${sectionId}"]`);
    const birthstoneAddButton = birthstonePanel?.querySelector('[data-birthstone-add]');
    const birthstoneError = birthstonePanel?.querySelector('[data-birthstone-error]');

    if (!birthstonePanel) return;

    loadBirthstoneData(birthstonePanel);

    if (infoButtons.length) {
      infoButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const handle = button.dataset.sidePanelPage || 'nos-pierres-de-naissance';
          openInfoPanel(handle);
        });
      });
    }
    if (giftNoteInfoButtons.length) {
      giftNoteInfoButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const handle = button.dataset.sidePanelPage || 'offert-avec-amour-par';
          openInfoPanel(handle);
        });
      });
    }

    if (birthstoneTrigger) {
      birthstoneTrigger.addEventListener('click', openBirthstonePanel);
    }

    if (birthstoneAddButton) {
      birthstoneAddButton.addEventListener('click', async () => {
        const selected = birthstonePanel.querySelector('input[type="radio"]:checked');
        if (!selected) {
          if (birthstoneError) birthstoneError.hidden = false;
          return;
        }
        if (birthstoneError) birthstoneError.hidden = true;
        const variantId = selected.dataset.birthstoneVariantId;
        if (!variantId) return;
        const productForm = document.getElementById(`product-form-${sectionId}`);
        const quantityValue = productForm
          ? parseInt(new FormData(productForm).get('quantity') || '1', 10) || 1
          : 1;
        const success = await addAddon(variantId, quantityValue);
        if (!success) return;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        const itemLabel = selected.closest('.birthstone-panel__item');
        const itemPrice = itemLabel?.querySelector('[data-birthstone-price]')?.textContent?.trim() || '';
        const thumbStyle = itemLabel?.querySelector('[data-birthstone-thumb]')?.style?.backgroundImage || '';
        const priceCents = parseInt(itemLabel?.dataset?.birthstonePriceCents || '0', 10) || 0;
        setBirthstoneSelected(birthstoneOption, birthstoneTrigger, birthstonePreview, selected, itemPrice, priceCents, thumbStyle);
        closeBirthstonePanel();
      });
    }

    if (birthstoneRemoveButton) {
      birthstoneRemoveButton.addEventListener('click', async () => {
        const variantId = birthstoneOption?.dataset?.birthstoneSelectedId;
        if (!variantId) {
          clearBirthstoneSelected(birthstoneOption, birthstoneTrigger, birthstonePreview);
          return;
        }
        const removed = await removeBirthstoneFromCart(variantId);
        if (!removed) return;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        clearBirthstoneSelected(birthstoneOption, birthstoneTrigger, birthstonePreview);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
